import {
  forwardRef,
  type ComponentType,
  type ForwardRefExoticComponent,
  type RefAttributes,
  type SVGProps,
} from 'react';

type ElementAttributes = RefAttributes<SVGSVGElement> & Partial<SVGProps<SVGSVGElement>>;
type SvgIcon = ComponentType<SVGProps<SVGSVGElement>>;

export interface DeckardIconProps extends ElementAttributes {
  size?: string | number;
  circle?: boolean;
  double?: boolean;
}
export type DeckardIcon = ForwardRefExoticComponent<
  Omit<DeckardIconProps, 'ref'> & RefAttributes<SVGSVGElement>
>;

export const DeckardIconWrapper = ({
  Icon,
  CircleIcon,
  DoubleIcon,
}: {
  Icon: SvgIcon;
  CircleIcon?: SvgIcon;
  DoubleIcon?: SvgIcon;
}): DeckardIcon =>
  forwardRef<SVGSVGElement, DeckardIconProps>(({ circle, double, ...rest }, ref) => {
    if (circle && CircleIcon) {
      return <CircleIcon ref={ref} className="deckard-icon" {...rest} />;
    }
    if (double && DoubleIcon) {
      return <DoubleIcon ref={ref} className="deckard-icon" {...rest} />;
    }
    return <Icon ref={ref} className="deckard-icon check" {...rest} />;
  });

//
